import React from 'react';
import { buildProvidersTree } from './buildProvidersTree.tsx';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from './IntlProvider.tsx';
import { QueryProvider } from './QueryProvider.tsx';
import { AuthProvider } from './AuthProvider.tsx';
import { ToastProvider } from './ToastProvider.tsx';
import { HelmetProvider } from 'react-helmet-async';

export const ProvidersWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const ProvidersTree = buildProvidersTree([
    [HelmetProvider],
    [Router],
    [QueryProvider],
    [IntlProvider],
    [AuthProvider],
    [ToastProvider],
  ]);

  return <ProvidersTree>{children}</ProvidersTree>;
};
